var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 186.12,
    viewBox: "0 0 160 186.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849",
    transform: "translate(6115 8967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_847",
    "data-name": "Group 847",
    transform: "translate(-6714 -9262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_384",
    "data-name": "Rectangle 384",
    transform: "translate(599 295)",
    fill: "rgba(255,255,255,0)",
    stroke: "#00b9ff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 80,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 157,
    height: 157,
    rx: 78.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848",
    transform: "translate(-6706.111 -9333.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M21.62,0a21.62,21.62,0,1,0,21.62,21.62A21.644,21.644,0,0,0,21.62,0Zm0,0",
    transform: "translate(649.111 509.111)",
    fill: "#00b9ff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M164,168.706l-12.862,12.862a1.977,1.977,0,0,1-2.8,0l-6.431-6.431a1.978,1.978,0,1,1,2.8-2.8l5.032,5.032L161.2,165.909a1.978,1.978,0,0,1,2.8,2.8Zm0,0",
    transform: "translate(517.777 356.993)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846",
    transform: "translate(362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M16,6.986A2.986,2.986,0,0,1,18.986,4H36.9a2.986,2.986,0,1,1,0,5.973H18.986A2.986,2.986,0,0,1,16,6.986Z",
    transform: "translate(-6398.205 -8918.041)",
    fill: "#00b9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(-7080 -9262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-photo",
    transform: "translate(652 338.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M19.537,6.624A8.959,8.959,0,0,1,25.872,4H36.836a2.986,2.986,0,1,1,0,5.973H25.872a2.986,2.986,0,0,0-2.112.875l-2.474,2.474a8.959,8.959,0,0,1-6.335,2.624H9.959a2.986,2.986,0,0,0-2.986,2.986V48.8a2.986,2.986,0,0,0,2.986,2.986H51.768A2.986,2.986,0,0,0,54.754,48.8v-20.9a2.986,2.986,0,1,1,5.973,0V48.8a8.959,8.959,0,0,1-8.959,8.959H9.959A8.959,8.959,0,0,1,1,48.8V18.932A8.959,8.959,0,0,1,9.959,9.973h4.992A2.986,2.986,0,0,0,17.063,9.1Z",
    transform: "translate(0 5.959)",
    fill: "#00b9ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M6,23.932A14.932,14.932,0,1,1,20.932,38.863,14.932,14.932,0,0,1,6,23.932Zm14.932-8.959a8.959,8.959,0,1,0,8.959,8.959A8.959,8.959,0,0,0,20.932,14.973Z",
    transform: "translate(9.932 15.891)",
    fill: "#00b9ff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M21.986,1a2.986,2.986,0,0,1,2.986,2.986V21.9A2.986,2.986,0,1,1,19,21.9V3.986A2.986,2.986,0,0,1,21.986,1Z",
    transform: "translate(687.754 338)",
    fill: "#00b9ff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraBlue);
export default __webpack_public_path__ + "static/media/cameraBlue.535dcae043647b628bde73950346ce67.svg";
export { ForwardRef as ReactComponent };